import { InputGroup } from 'react-bootstrap';
import React from 'react';
import './styles.scss';
var UIFormInput = function UIFormInput(_ref) {
    var measure = _ref.measure, value = _ref.value, onChange = _ref.onChange, label = _ref.label, className = _ref.className, placeholder = _ref.placeholder, _ref$type = _ref.type, type = _ref$type === void 0 ? 'number' : _ref$type, id = _ref.id, idLabel = _ref.idLabel, name = _ref.name, min = _ref.min, max = _ref.max;
    return /*#__PURE__*/ React.createElement(InputGroup, {
        className: "align-items-center"
    }, /*#__PURE__*/ React.createElement(InputGroup.Text, {
        id: idLabel,
        className: className
    }, label), /*#__PURE__*/ React.createElement("input", {
        className: "form-control",
        type: type,
        placeholder: placeholder,
        "aria-label": label.toLowerCase(),
        value: value,
        onChange: onChange,
        id: id,
        name: name,
        min: min,
        max: max
    }), measure && /*#__PURE__*/ React.createElement("span", {
        className: "measure-input"
    }, measure));
};
export default /*#__PURE__*/ React.memo(UIFormInput);
